import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home } from "lucide-react";
import Seo from "../Components/Seo";

const NotFoundPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo
        title="Page Not Found | Triguna Solutions"
        description="The page you're looking for could not be found."
        path="/404"
      />
      <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-brand-gradient-dark px-4 py-20">
        <div className="pointer-events-none absolute -left-24 top-10 h-96 w-96 rounded-full bg-primary/30 blur-3xl" />
        <div className="pointer-events-none absolute -right-24 bottom-10 h-96 w-96 rounded-full bg-accent/20 blur-3xl" />
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="relative text-center"
        >
          <p className="font-display text-7xl font-bold text-amber-300 sm:text-9xl">404</p>
          <h1 className="mt-4 font-display text-2xl font-bold text-white sm:text-3xl">
            Page not found
          </h1>
          <p className="mx-auto mt-3 max-w-md text-purple-100/80">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <button
            onClick={() => navigate("/")}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-gradient px-7 py-3.5 text-base font-semibold text-white shadow-lg shadow-primary/30"
          >
            <Home className="h-5 w-5" />
            Back to Home
          </button>
        </motion.div>
      </section>
    </>
  );
};

export default NotFoundPage;
